import { Link } from 'react-router-dom';

const services = [
  'Channel Letter Signs', 'Monument Signs', 'LED / Illuminated Signs',
  'Storefront Signs', 'Vehicle Wraps & Fleet Graphics', 'Interior Signs',
  'ADA & Wayfinding Signs', 'Banners & Event Signage',
];

const areas = ['Austin', 'Round Rock', 'Cedar Park', 'Pflugerville', 'Georgetown', 'Leander'];

const links = [
  { label: 'Home', href: '/' }, { label: 'Services', href: '/services' },
  { label: 'About Us', href: '/about' }, { label: 'Contact', href: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#080808]" style={{ borderTop: '1px solid #1E1E1E' }}>
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-8 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://capitalareasigns.com/wp-content/uploads/2026/01/Capital-Area-Signs-Logo-164PX.png"
              alt="Capital Area Signs"
              className="h-12 w-auto object-contain mb-7"
              style={{ filter: 'drop-shadow(0 1px 6px rgba(0,0,0,0.5))' }}
            />
            <p className="text-white/45 text-sm leading-relaxed mb-8 max-w-xs">
              Premium commercial signage — designed, fabricated, and installed by experts who understand that your sign is your first impression.
            </p>
            <div className="flex items-center gap-3 mb-8">
              {[
                { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/capitalareasigns' },
                { icon: 'ri-twitter-x-fill', href: 'https://x.com/capitalsigns' },
                { icon: 'ri-whatsapp-fill', href: 'https://wa.me/15127990115' },
              ].map((s) => (
                <a key={s.href} href={s.href} target="_blank" rel="nofollow noopener"
                  className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-sm text-white/40 hover:text-[#C4962A] hover:border-[#C4962A]/40 transition-all cursor-pointer">
                  <i className={`${s.icon} text-xs`} />
                </a>
              ))}
            </div>
            <img
              src="https://capitalareasigns.com/wp-content/uploads/2020/10/cards.png"
              alt="Accepted payment methods"
              className="h-7 w-auto object-contain opacity-40"
            />
          </div>

          {/* Services */}
          <div>
            <p className="eyebrow mb-6">Services</p>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <Link to="/services"
                    className="text-white/40 text-sm hover:text-white/80 transition-colors flex items-center gap-2.5 cursor-pointer">
                    <span className="w-4 h-px bg-[#C4962A]/50 flex-shrink-0" />
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links + Areas */}
          <div>
            <p className="eyebrow mb-6">Company</p>
            <ul className="space-y-3 mb-10">
              {links.map((l) => (
                <li key={l.href}>
                  <Link to={l.href}
                    className="text-white/40 text-sm hover:text-white/80 transition-colors flex items-center gap-2.5 cursor-pointer">
                    <span className="w-4 h-px bg-[#C4962A]/50 flex-shrink-0" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="eyebrow mb-4">Service Areas</p>
            <div className="flex flex-wrap gap-2">
              {areas.map((city) => (
                <span key={city}
                  className="text-xs text-white/35 border border-white/8 px-2.5 py-1 rounded-sm">
                  {city}
                </span>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="eyebrow mb-6">Contact</p>
            <div className="space-y-6">
              <a href="tel:+15127990115" className="flex items-start gap-4 group cursor-pointer">
                <span className="w-9 h-9 flex items-center justify-center border border-[#C4962A]/30 rounded-sm flex-shrink-0 mt-0.5">
                  <i className="ri-phone-fill text-[#C4962A] text-sm" />
                </span>
                <div>
                  <p className="text-white/30 text-xs uppercase tracking-widest mb-1">Phone</p>
                  <p className="text-white/75 text-sm font-semibold group-hover:text-[#C4962A] transition-colors">(512) 799-0115</p>
                  <p className="text-white/30 text-xs mt-0.5">Click to call</p>
                </div>
              </a>
              <a href="mailto:chris@capitalareasign.com" className="flex items-start gap-4 group cursor-pointer">
                <span className="w-9 h-9 flex items-center justify-center border border-[#C4962A]/30 rounded-sm flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-[#C4962A] text-sm" />
                </span>
                <div>
                  <p className="text-white/30 text-xs uppercase tracking-widest mb-1">Email</p>
                  <p className="text-white/75 text-sm group-hover:text-[#C4962A] transition-colors">chris@capitalareasign.com</p>
                </div>
              </a>
              <div className="flex items-start gap-4">
                <span className="w-9 h-9 flex items-center justify-center border border-[#C4962A]/30 rounded-sm flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-2-fill text-[#C4962A] text-sm" />
                </span>
                <div>
                  <p className="text-white/30 text-xs uppercase tracking-widest mb-1">Location</p>
                  <p className="text-white/75 text-sm">Austin, Texas</p>
                  <p className="text-white/30 text-xs mt-0.5">Serving Central Texas</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs tracking-wide">
            &copy; {new Date().getFullYear()} Capital Area Signs. All rights reserved. Austin, TX.
          </p>
          <div className="flex items-center gap-6 text-white/20 text-xs">
            <span className="hover:text-white/50 cursor-pointer transition-colors">Privacy Policy</span>
            <span className="hover:text-white/50 cursor-pointer transition-colors">Terms of Service</span>
            <span className="hover:text-white/50 cursor-pointer transition-colors">Accessibility</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
